import { render, staticRenderFns } from "./RecursosPagina.vue?vue&type=template&id=2fa3a8d2&scoped=true"
import script from "./RecursosPagina.vue?vue&type=script&lang=js"
export * from "./RecursosPagina.vue?vue&type=script&lang=js"
import style0 from "./RecursosPagina.vue?vue&type=style&index=0&id=2fa3a8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa3a8d2",
  null
  
)

export default component.exports